import { CdsColorBackgroundPrimaryMain } from '@cegid/design-tokens';
import { Avatar, Box, Paper, Typography } from '@mui/material';
import ContextualInfo from 'Components/ContextualInfo';
import { useStyles } from './TopProfile.styles';

interface Props {
  name: string;
  colorBlockBgColor?: string;
  youConsultSentence?: string;
  colorBlockTitle?: string;
  colorBlockSubTitle?: string;
  contextualHelpContent?: string;
  titleId?: string;
  subtitleId?: string;
}

function TopProfile({ name, colorBlockBgColor, youConsultSentence, colorBlockTitle, colorBlockSubTitle, contextualHelpContent, titleId, subtitleId }: Readonly<Props>) {
  const classes = useStyles();
  return (
    <>
      <Box className={classes.header} style={{ maxWidth: '100%' }} p={2}>
        <Avatar variant="square" classes={{ root: classes.avatar }} role="avatar" style={{ backgroundColor: colorBlockBgColor ?? CdsColorBackgroundPrimaryMain }}>
          {name?.charAt(0)}
        </Avatar>
        <Typography variant="h5" color="textSecondary" paragraph>
          {youConsultSentence}
        </Typography>
        <Typography variant="h5" style={{ maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis' }} paragraph>
          {name}
        </Typography>
      </Box>
      <Paper
        style={{
          padding: '2em',
          marginBottom: '1em',
          background: colorBlockBgColor ?? CdsColorBackgroundPrimaryMain,
          color: 'white'
        }}
      >
        <Typography paragraph variant="h5" data-testid={titleId}>
          {colorBlockTitle}
        </Typography>
        <Typography
          variant="body1"
          component="div"
          style={{ opacity: 0.6, display: 'flex', alignItems: 'center' }}
          data-testid={subtitleId}
        >
          <div style={{ wordWrap: 'break-word', maxWidth: '95%' }}>{colorBlockSubTitle}</div>
          {contextualHelpContent && (
            <ContextualInfo
              color="inherit"
              content={contextualHelpContent}
              role="help"
              style={{ marginLeft: '8px' }}
            />
          )}
        </Typography>
      </Paper>
    </>
  );
}

export default TopProfile;
